import { api } from '../index';

const prefix = '/api/item/item_master/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectItemList(param) {
	return api.post(prefix + 'selectItemList', param);
}

export function apiSelectItemInventoryList(param) {
	return api.post(prefix + 'selectItemInventoryList', param);
}

export function apiSelectItem(param) {
	return api.post(prefix + 'selectItem', param);
}

export function apiCheckItemExists(param) {
	return api.post(prefix + 'checkItemExists', param);
}

export function apiInsertItem(param) {
	param.mode = 'insert';
	return apiSubmitItem(param);
}

export function apiUpdateItem(param) {
	param.mode = 'update';
	return apiSubmitItem(param);
}

export function apiDeleteItem(param) {
	param.mode = 'delete';
	return apiSubmitItem(param);
}

function apiSubmitItem(param) {
	return api.post(prefix + 'submitItem', param);
}
export function apiSelectItemByBarcode(barcode) {
	return api.get(prefix + 'label/' + barcode);
}

export function apiBatchSubmit(param) {
	return api.post(prefix + 'batchSubmit', param);
}

export function apiBatchInactivate(param) {
	return api.post(prefix + 'batchInactivate', param);
}

export function apiBatchActivate(param) {
	return api.post(prefix + 'batchActivate', param);
}

export function apiBatchRetailOff(param) {
	return api.post(prefix + 'batchRetailOff', param);
}

export function apiBatchRetailOn(param) {
	return api.post(prefix + 'batchRetailOn', param);
}

// #3320 Sales On/Off 일괄 변경(jc 전용). 서버가 세션 회사가 jc 가 아니면 아무것도 쓰지 않는다.
export function apiBatchSalesOff(param) {
	return api.post(prefix + 'batchSalesOff', param);
}

export function apiBatchSalesOn(param) {
	return api.post(prefix + 'batchSalesOn', param);
}

export function apiUpdateCostBatch(param) {
	return api.post(prefix + 'updateCostBatch', param);
}

export function apiResetBackOrderCountBatch(param) {
	return api.post(prefix + 'resetBackOrderCountBatch', param);
}

export function apiInsertPicture(param) {
	return api.post(prefix + 'insertPicture', param);
}

export function apiDeletePicture(param) {
	return api.post(prefix + 'deletePicture', param);
}

export function apiBulkUploadPictures(files) {
	const formData = new FormData();
	for (let i = 0; i < files.length; i++) {
		formData.append('files', files[i]);
	}
	return api.post(prefix + 'bulkUploadPictures', formData, {
		headers: {
			'Content-Type': 'multipart/form-data',
		},
	});
}

export function apiLoadFromExcel(param) {
	return api.post(prefix + 'loadFromExcel', param);
}

/** PO Excel 업로드(Style + Color) 전용. #WK-20260821-05 */
export function apiLoadFromExcelForPurchase(param) {
	return api.post(prefix + 'loadFromExcelForPurchase', param);
}

export function apiCheckImportFromExcel(param) {
	return api.post(prefix + 'checkImportFromExcel', param);
}

export function apiImportFromExcel(param) {
	return api.post(prefix + 'importFromExcel', param);
}

export function apiInventoryStatus(param) {
	return api.get(prefix + 'inventoryStatus/data' + param);
}

export function apiInventoryStatusRawData(param) {
	return api.get(prefix + 'inventoryStatus/rawData' + param);
}

export function apiSelectUpcInventoryItems(param) {
	return api.post(prefix + 'upc-inventory-item', param);
}

// #3341 JC Barcode List
export function apiSelectBarcodeListItems(param) {
	return api.post(prefix + 'barcode-list-item', param);
}

export function apiGetNewBarcode() {
	return api.get(prefix + 'getNewBarcode');
}
